// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Dataset
 */
export interface Dataset {
  /**
   *
   */
  id: string;
  /**
   *
   */
  inputType?: DatasetInputTypeEnum;
}

/**
 * @export
 */
export const DatasetInputTypeEnum = {
  Dataset: "dataset",
} as const;
export type DatasetInputTypeEnum = (typeof DatasetInputTypeEnum)[keyof typeof DatasetInputTypeEnum];

/**
 * Check if a given object implements the Dataset interface.
 */
export function instanceOfDataset(value: object): value is Dataset {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function DatasetFromJSON(json: any): Dataset {
  return DatasetFromJSONTyped(json, false);
}

export function DatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Dataset {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    inputType: json["input_type"] == null ? undefined : json["input_type"],
  };
}

export function DatasetToJSON(json: any): Dataset {
  return DatasetToJSONTyped(json, false);
}

export function DatasetToJSONTyped(
  value?: Dataset | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    input_type: value["inputType"],
  };
}
